var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolonezQrcode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA0029",
    d: "M2 3.714C2 2.768 2.768 2 3.714 2h3.429c.946 0 1.714.768 1.714 1.714v3.429c0 .946-.768 1.714-1.714 1.714H3.714A1.715 1.715 0 0 1 2 7.143zm2.286.572V6.57H6.57V4.286zM2 12.857c0-.946.768-1.714 1.714-1.714h3.429c.946 0 1.714.768 1.714 1.714v3.429c0 .946-.768 1.714-1.714 1.714H3.714A1.715 1.715 0 0 1 2 16.286zm2.286.572v2.285H6.57V13.43H4.286ZM12.857 2h3.429C17.232 2 18 2.768 18 3.714v3.429c0 .946-.768 1.714-1.714 1.714h-3.429a1.715 1.715 0 0 1-1.714-1.714V3.714c0-.946.768-1.714 1.714-1.714m2.857 2.286H13.43V6.57h2.285V4.286Zm-4.571 7.428c0-.314.257-.571.571-.571H14c.314 0 .571.257.571.571 0 .315.258.572.572.572h1.143a.573.573 0 0 0 .571-.572.573.573 0 0 1 1.143 0v3.429a.573.573 0 0 1-.571.571h-2.286a.573.573 0 0 1-.572-.571.573.573 0 0 0-.571-.572.573.573 0 0 0-.571.572v2.286a.573.573 0 0 1-.572.571h-1.143a.573.573 0 0 1-.571-.571zm4 6.286a.571.571 0 1 1 0-1.143.571.571 0 0 1 0 1.143m2.286 0a.571.571 0 1 1 0-1.143.571.571 0 0 1 0 1.143"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolonezQrcode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polonez-qrcode.76ba9c3f5f889afe11a21ec367ca845a.svg";